import { render, staticRenderFns } from "./centralizedManagement.vue?vue&type=template&id=fc4b095a&scoped=true&"
import script from "./centralizedManagement.vue?vue&type=script&lang=js&"
export * from "./centralizedManagement.vue?vue&type=script&lang=js&"
import style0 from "./centralizedManagement.vue?vue&type=style&index=0&id=fc4b095a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4b095a",
  null
  
)

export default component.exports